export default __webpack_public_path__ + "static/media/habano3.42308ebf.png";